// File: packages/core/src/hooks/session/useSessionState.js
import { useState } from 'react';

export const useSessionState = () => {
    const [sessionId, setSessionId] = useState(null);
    const [isConnected, setIsConnected] = useState(false);
    const [isInitializing, setIsInitializing] = useState(false);
    const [processingStatus, setProcessingStatus] = useState('idle');
    const [showProcessUpdates, setShowProcessUpdates] = useState(true);
    const [isSending, setIsSending] = useState(false);
    const [hasAuthFailed, setHasAuthFailed] = useState(false);
    const [reconnectPendingOnShutdown, setReconnectPendingOnShutdown] = useState(false);
    const [isReconnecting, setIsReconnecting] = useState(false);
    const [reconnectAttempts, setReconnectAttempts] = useState(0);
    const [reconnectTrigger, setReconnectTrigger] = useState(0);
    const [timelineItems, setTimelineItems] = useState([]);
    const [sessionContext, setSessionContext] = useState([]);
    const [teamName, setTeamName] = useState(null);
    const [needsNewSession, setNeedsNewSession] = useState(false);
    const [preChatState, setPreChatState] = useState(null);
    const [activeWidgets, setActiveWidgets] = useState([]);
    const [isIdleDisconnected, setIsIdleDisconnected] = useState(false);

    return {
        sessionId, setSessionId,
        isConnected, setIsConnected,
        isInitializing, setIsInitializing,
        processingStatus, setProcessingStatus,
        showProcessUpdates, setShowProcessUpdates,
        isSending, setIsSending,
        hasAuthFailed, setHasAuthFailed,
        reconnectPendingOnShutdown, setReconnectPendingOnShutdown,
        isReconnecting, setIsReconnecting,
        reconnectAttempts, setReconnectAttempts,
        reconnectTrigger, setReconnectTrigger,
        timelineItems, setTimelineItems,
        sessionContext, setSessionContext,
        teamName, setTeamName,
        needsNewSession, setNeedsNewSession,
        preChatState, setPreChatState,
        activeWidgets, setActiveWidgets,
        isIdleDisconnected, setIsIdleDisconnected,
    };
};